<template>
  <lab-dialog :visible="visible" :title="title" @close="close">
    <p class="lab-note">请使用系统下载的 Excel 模板，填写后上传；整批校验通过后才会保存。</p>
    <p v-if="error" class="lab-error" role="alert">{{ error }}</p>
    <operation-message :value="notice" type="success" @consumed="notice = ''" />
    <div class="form-grid">
      <div class="form-item full">
        <label for="excel-import-file">Excel 导入文件</label>
        <input id="excel-import-file" ref="file" type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="field full" :disabled="busy" @change="selectFile">
        <small class="hint">仅支持 .xlsx，文件不超过 8MB；模板中的“{{ sheetName }}”工作表为数据页，空白行会自动跳过。</small>
      </div>
    </div>
    <p v-if="file" class="hint">已选择：{{ file.name }}</p>
    <template #footer>
      <button class="btn" :disabled="busy" @click="downloadTemplate">{{ downloading ? '下载中…' : '下载 Excel 模板' }}</button>
      <button class="btn" :disabled="busy" @click="close">取消</button>
      <button class="btn primary" :disabled="!file || busy" @click="submit">{{ importing ? '上传校验中…' : '校验并导入' }}</button>
    </template>
  </lab-dialog>
</template>

<script>
import LabDialog from './NetworkLabDialog.vue'
import { errorText } from '../services/api'
import http from '../services/http'

export default {
  name: 'ExcelImportDialog',
  components: { LabDialog },
  props: {
    visible: Boolean,
    title: { type: String, required: true },
    sheetName: { type: String, required: true },
    importUrl: { type: String, required: true },
    templateUrl: { type: String, required: true },
    templateName: { type: String, required: true }
  },
  data () { return { file: null, error: '', notice: '', importing: false, downloading: false } },
  computed: { busy () { return this.importing || this.downloading } },
  watch: { visible () { this.reset() } },
  methods: {
    reset () { this.file = null; this.error = ''; this.notice = ''; if (this.$refs.file) this.$refs.file.value = '' },
    close () { if (this.busy) return; this.reset(); this.$emit('close') },
    selectFile (event) {
      const file = event.target.files && event.target.files[0]
      this.file = null; this.error = ''; this.notice = ''
      if (!file) return
      if (!/\.xlsx$/i.test(file.name)) { event.target.value = ''; this.error = '请选择 .xlsx 格式的 Excel 模板'; return }
      if (file.size > 8 * 1024 * 1024) { event.target.value = ''; this.error = 'Excel 文件不能超过 8MB'; return }
      this.file = file
    },
    async downloadTemplate () {
      if (this.busy) return
      this.error = ''; this.notice = ''; this.downloading = true
      try {
        const response = await http.get(this.templateUrl, { responseType: 'blob' })
        const url = URL.createObjectURL(response.data); const link = document.createElement('a')
        link.href = url; link.download = this.templateName; document.body.appendChild(link); link.click(); link.remove()
        window.setTimeout(() => URL.revokeObjectURL(url), 1000)
        this.notice = 'Excel 导入模板已下载'
      } catch (error) { this.error = errorText(error); this.$message.error(this.error) } finally { this.downloading = false }
    },
    async submit () {
      if (this.busy) return
      if (!this.file) { this.error = '请先选择 Excel 导入文件'; return }
      this.error = ''; this.notice = ''; this.importing = true
      try {
        const form = new FormData(); form.append('file', this.file)
        const response = await http.post(this.importUrl, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        this.$emit('imported', response.data.data || {})
        this.$emit('close')
      } catch (error) { this.error = errorText(error); this.$message.error(this.error) } finally { this.importing = false }
    }
  }
}
</script>
